import { render, staticRenderFns } from "./sectionVideo.vue?vue&type=template&id=e2773142&"
import script from "./sectionVideo.vue?vue&type=script&lang=js&"
export * from "./sectionVideo.vue?vue&type=script&lang=js&"
import style0 from "./sectionVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports